import { render } from "./TempPayments.vue?vue&type=template&id=9a51b31a&scoped=true"
import script from "./TempPayments.vue?vue&type=script&lang=js"
export * from "./TempPayments.vue?vue&type=script&lang=js"

import "./TempPayments.vue?vue&type=style&index=0&id=9a51b31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a51b31a"]])

export default __exports__